export function safeForInnerHtml(str:string, toRemoveTags:string[] = ["script", "style"]):string{
	let rootEl = document.createElement("div");
	rootEl.innerHTML = str;
	function checkChildren(el:Element){
		for (let i = el.children.length -1; i >= 0; i--){
			let thisEl = el.children.item(i);
			if (!thisEl) return;
			let attributes = thisEl.attributes;
			for (let i = attributes.length - 1; i >= 0; i--){
				let attr = attributes.item(i);
				if (!attr) continue;
				if (attr.name.toLowerCase().startsWith("on")){
					thisEl.removeAttributeNS(attr.namespaceURI, attr.name);
				}
			}
			if (toRemoveTags.indexOf(thisEl.tagName) != -1){
				thisEl.remove();
			}
			if (thisEl.children.length != 0){
				checkChildren(thisEl);
			}
		}
	}
	checkChildren(rootEl);
	return rootEl.innerHTML;
}